export default __webpack_public_path__ + "static/media/bellIcon.42d3b637.svg";